// LegendAndFilters.jsx
import React from 'react';

const LegendAndFilters = ({ activeFilters, onFilterToggle }) => {
  return (
    <div className="mb-4">
      <div className="mb-4">
        <h3 className="text-lg font-medium mb-2">Legend:</h3>
        <div className="flex flex-wrap">
          <div className="flex items-center mr-4 mb-2">
            <div className="w-4 h-4 rounded-full bg-red-500 mr-2"></div>
            <span>Mutation</span>
          </div>
          <div className="flex items-center mr-4 mb-2">
            <div className="w-4 h-4 rounded-full bg-blue-500 mr-2"></div>
            <span>Drugs</span>
          </div>
          <div className="flex items-center mr-4 mb-2">
            <div className="w-4 h-4 rounded-full bg-green-500 mr-2"></div>
            <span>Pathway</span>
          </div>
          <div className="flex items-center mr-4 mb-2">
            <div className="w-4 h-4 rounded-full bg-purple-500 mr-2"></div>
            <span>Outcomes</span>
          </div>
        </div>
      </div>
     
      <div>
        <h3 className="text-lg font-medium mb-2">Filters:</h3>
        <div className="space-y-2">
          <div className="inline-block mr-2 mb-2">
            <button 
              className={`px-3 py-1 rounded ${activeFilters.fdaApproved ? 'bg-blue-500 text-white' : 'border border-blue-500 text-blue-500'}`}
              onClick={() => onFilterToggle('fdaApproved')}
            >
              FDA Approved Treatments
            </button>
          </div>
          <div className="inline-block mr-2 mb-2">
            <button 
              className={`px-3 py-1 rounded ${activeFilters.clinicalTrials ? 'bg-blue-500 text-white' : 'border border-blue-500 text-blue-500'}`}
              onClick={() => onFilterToggle('clinicalTrials')}
            >
              Clinical Trial Options
            </button>
          </div>
          <div className="inline-block mb-2">
            <button 
              className={`px-3 py-1 rounded ${activeFilters.theoretical ? 'bg-blue-500 text-white' : 'border border-blue-500 text-blue-500'}`}
              onClick={() => onFilterToggle('theoretical')}
            >
              Theoretical Mechanisms
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegendAndFilters;